export default __webpack_public_path__ + "static/header-90-years-logo-white-95a67926b988b69044eaf5068e08c880.png";